/**
 * The Stears wordmark, as published on stears.co (`/images/stears-logo-white.webp`,
 * white on transparent, 150x43). Height is set and width follows, because forcing
 * both squashes the mark.
 */
export function StearsLogo({ height = 24 }: { height?: number }) {
  return (
    <img
      src="/images/stears-logo-white.webp"
      alt="Stears"
      style={{ height, width: 'auto' }}
    />
  )
}

/**
 * The brand bar every standalone company-facing screen opens with: the landing
 * page, the submitted status page, the no-request page and the invalid-link page.
 * Screens inside the form get their branding from `PortalTopBar` instead, so this
 * is deliberately not used there.
 */
export function PortalBrandBar() {
  return (
    <div style={{ padding: '20px 20px 0' }}>
      <StearsLogo />
    </div>
  )
}
